export const ACTIONS_ENABLED_STATUSES = [
    'На рассмотрении', 'Being considered',
    'Не прочитана', 'Not read',
    'На согласовании', 'On approval'
];

export const ACTIVE_STATUSES = [ 'На рассмотрении', 'Being considered' ];
